import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import {
  ZERO_RESULTS,
  NOT_DELIVERABLE,
  EMPTY_STRING
} from 'base/constants/errorTypes';

const useStyles = makeStyles(theme => ({
  root: {
    color: ({ color }) => {
      return color === 'error' ? theme.palette.error.main : color;
    }
  }
}));

const Error = ({ status, color }) => {
  const classes = useStyles({ color });
  let message = '';
  if (status === ZERO_RESULTS) {
    message =
      "Sorry we couldn't find your address. Please select an option from the dropdown.";
  }
  if (status === NOT_DELIVERABLE) {
    message =
      "Sorry, we don't deliver to your address. Please switch to Pickup or try a different address.";
  }
  return message ? <Typography classes={classes}>{message}</Typography> : null;
};

// local state in these components is initialized with error: ''

Error.propTypes = {
  color: PropTypes.string,
  status: PropTypes.oneOf([ZERO_RESULTS, NOT_DELIVERABLE, EMPTY_STRING])
};

Error.defaultProps = {
  color: 'error'
};

export default Error;
